<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-default">
            </div>
            <div class="container shape-container pt-md">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-7">
                        <h2 class="text-white display-1">Últimos Títulos <span>Cadastrados</span></h2>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <base-pagination :total="total_titulos" :per-page="20" v-model="page" align="center" :disabled="$wait.is('novidades.load')"></base-pagination>
                <v-wait for="novidades.load"> 
                  <template slot="waiting">
                    <div class="text-center">
                      <p class="lead">Aguarde, carregando títulos..</p>
                    </div>
                  </template>
                  <div v-if="!titulos.length">
                    <div class="text-center">
                      <p class="lead">Não há novidades para exibir</p>
                    </div>
                  </div>
                  <div class="table-responsive" v-else>
                    <table class="table table-striped novidades">
                      <thead>
                          <tr>
                            <th><strong>Capa</strong></th>
                            <th><strong>Título</strong></th>
                            <th class="text-center"><strong>Fonte</strong></th>
                            <th class="text-center"><strong>Dublagem</strong></th>
                            <th class="text-center"><strong>Legendas</strong></th>
                            <th class="text-right"><strong>Cadastro</strong></th>
                          </tr>
                      </thead>
                      <tbody>
                        <template v-for="titulo in titulos">
                          <tr :key="titulo.id" :class="[titulo.preco ? 'gold' : '']">
                            <td>
                              <img :src="titulo.cover" width="90">
                            </td>
                            <td><strong>{{titulo.titulo}}</strong><br>
                            <img width="20" height="20" :src="[titulo.formato ? 'img/mediaformat/'+titulo.formato+'.svg' : '']">
                            {{titulo.formato}}
                            <base-button type="success" size="sm" class="d-table mt-2" @click="addToCart([titulo,])">
                              Adicionar
                            </base-button>
                            </td>
                            <td class="text-center"><span class="badge badge-info">{{titulo.origem}}</span>
                            </td>
                            <td class="text-center"><small>{{titulo.estudio_dublagem}}</small></td>
                            <td class="text-center"><small>{{titulo.legendas}}</small></td>
                            <td class="text-right"><strong>{{titulo.data_cadastro}}</strong></td>
                          </tr>
                          <tr v-if="titulo.episodios && titulo.episodios.length > 0" :key="titulo.id" :class="[titulo.preco ? 'gold' : '']">
                            <td width="90"></td>
                            <td colspan="5">
                              <div class="episodios">
                                <strong>Episódios presentes na mídia:</strong>
                                <p v-for="episodio in titulo.episodios" :key="episodio.id" :title="episodioFormat(episodio)">
                                  {{episodioFormat(episodio)}}
                                </p>
                              </div>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </v-wait>
                <base-pagination :total="total_titulos" :per-page="20" v-model="page" align="center" :disabled="$wait.is('novidades.load')"></base-pagination>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import BasePagination from '@/components/BasePagination';

export default {
  name: "recentmedia",
  components: {
    BasePagination
  },
  data() {
      return {
        total_titulos: 0,
        titulos: [],
        page: ( !this.$route.query.pagina ) ? 1 : parseInt(this.$route.query.pagina),
        modal: {
            title: '', 
            body: '', 
            classe: '', 
            icon: 'ni ni-basket', 
            okButton: 'OK'
          },
      }
    },
    computed: {
        ...mapGetters('cart', [
          'sacolaCheia',
        ]),
      },
    watch: {
      page(newValue) {
        this.$router.push({ query: { ...this.$route.query, pagina: newValue }});
      },
      '$route' (to, from) {
        this.page = ( !this.$route.query.pagina ) ? 1 : parseInt(this.$route.query.pagina)
        this.loadRecentes();
      }
    },
    methods: {
      ...mapActions('cart', [
        'addMedia',
      ]),
      episodioFormat(episodio) {
        let episodioString = '';
        if ( episodio.temporada ) {
          episodioString += episodio.temporada+'x';
        }
        if ( episodio.episodio ) {
          episodioString += episodio.episodio+' - ';
        }
        episodioString += episodio.titulo_traduzido+ ' ('+episodio.ano+')';
        episodioString += ' - '+ episodio.duracao +'min';
        return episodioString;
      },
      makeURLparams(data) {
        return Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&');
      },
      updateModalInfo(data) {
          this.modal.title = data.title;
          this.modal.body = data.body;
          this.modal.classe = data.classe;
          this.$store.dispatch('modal/invokeStateModal', this.modal);
        },
        addToCart(selected) {
          if ( this.sacolaCheia == true ) {
            let modalObject = {
              title: 'Carrinho Cheio!',
              body: 'Seu carrinho atingiu o limite de mídias por pedido',
              classe: 'modal-warning'
            };
            this.updateModalInfo(modalObject);
          }else {
            this.addMedia(selected).then((response) => {
              if ( this.$store.state.cart.add_media_complete == true ) {
                if ( this.$store.state.cart.cart_item_exists == true ) {
                  let modalObject = {
                    title: 'Sacola de Títulos',
                    body: 'A mídia já existe na sua Sacola de Títulos',
                    classe: 'modal-info'
                  };
                  this.updateModalInfo(modalObject);
                }else {
                  let modalObject = {
                    title: 'Sacola de Títulos Atualizada!',
                    body: 'Você incluiu novas mídias em sua Sacola de Títulos',
                    classe: 'modal-success'
                  };
                  this.updateModalInfo(modalObject);
                }
              }
            });
          }
        },
      toggleModal () {
        this.showModal = !this.showModal
      },
      loadRecentes() {
        var objQuery = {};

        let checkPageQuery = ( this.page > 0 ) ? true : false;
        if ( checkPageQuery == true ) {
          objQuery['page'] = this.page;
        }

        var queryString = '?'+this.makeURLparams(objQuery);

        this.$wait.start('novidades.load');
        this.axios.get('v1/titulos/novidades'+queryString)
          .then(response => {
            this.total_titulos = response.data.count;
            this.titulos = [];
            response.data.results.forEach((item) => {
                item.cover = this.axios.defaults.baseURL + item.capa;
                this.titulos.push(item);
            })
          })
          .catch(e => {
            //console.log(e.message)
          })
          .then(data => {
            this.$wait.end('novidades.load');
          });
        }
    },
    created() {
      this.loadRecentes();
    }
};
</script>
<style lang="scss" scoped>
    table.novidades {
        tbody {
            tr {
                td {
                    vertical-align: middle;
                }
            }
        }
    }
    div.episodios {
      p {
        display: block;
        clear: both;
        margin-bottom: 1px;
        font-size: 0.9em;
      }

    }
</style>
